import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import Header from "../components/Header";
import usePageMeta from "../utils/usePageMeta";

const LeagueAccessDeniedPage = () => {
    usePageMeta({
        title: "League Access Denied",
        description:
            "This league exists, but it is not linked to your DoritoStats account.",
    });

    return (
        <div className="min-h-screen bg-bg flex flex-col">
            <Header />

            <div className="bg-forest border-b-4 border-mustard">
                <div className="max-w-5xl mx-auto px-6 py-8">
                    <div className="flex items-center gap-3">
                        <Lock
                            className="w-8 h-8 text-mustard flex-shrink-0"
                            aria-hidden="true"
                        />
                        <h1 className="font-display text-4xl font-black text-white leading-none">
                            Access Denied
                        </h1>
                    </div>
                </div>
            </div>

            <main className="flex-1 max-w-5xl mx-auto w-full px-4 sm:px-6 py-12">
                <div className="bg-surface border border-border-card rounded-card shadow-card p-8 max-w-xl">
                    <p className="text-ds-text font-sans text-base leading-relaxed mb-2">
                        This league is not linked to your account, so DoritoStats
                        can’t load it for you.
                    </p>
                    <p className="text-text-muted font-sans text-sm mb-6">
                        Ask the league owner for a share link, or add the league
                        from the signup flow to link it to your account.
                    </p>
                    <Link
                        to="/dashboard"
                        className="inline-block px-5 py-2.5 bg-mustard text-forest font-sans font-extrabold text-sm rounded-lg shadow-mustard hover:bg-yellow-500 transition-colors"
                    >
                        Back to Dashboard
                    </Link>
                </div>
            </main>
        </div>
    );
};

export default LeagueAccessDeniedPage;

